import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';
/* Utils */
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';
/* Constants */
import { BASICS_STEP } from 'site-modules/shared/constants/financing/steps';

export function PrequalNotFoundScreenError({ isMatchingVIN = false, isPreVinFlow = false }) {
  return (
    <div
      className="text-center"
      data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'prequal_not_found' })}
    >
      <h2 className="size-30 fw-bold mb-1">Pre-Qualification Request Not Found</h2>
      <h4 className="size-20 mb-1 fw-normal">Sorry we were not able to find your pre-qualification request.</h4>
      <div className="mb-1">Please submit a new request to see if you pre-qualify for financing.</div>
      <div className="d-flex justify-content-center w-100">
        <Button
          className="px-1 mb-2 text-white text-decoration-none text-capitalize size-16 fw-normal"
          tag={Link}
          to={`../${BASICS_STEP}`}
          color="primary-b"
          rel="nofollow"
        >
          Get Started
          <i className="ms-0_5 size-12 icon-arrow-right4" aria-hidden />
        </Button>
      </div>
    </div>
  );
}

PrequalNotFoundScreenError.propTypes = {
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
